import { TokenIcons, ChainIcons } from '../assets/images';

export interface Token {
  coinIcon: string;
  symbol: string;
  chainName: string;
  chain: string;
  chainIcon: string;
  balance: number;
  balanceTousd: number;
  address: string;
  contract: string;
  decimals: number;
  chainId: string;
}

export const TokenList: Token[] = [
  {
    coinIcon: TokenIcons.BWB,
    symbol: 'BWB',
    chainName: 'Ethereum',
    chain: 'eth',
    chainIcon: ChainIcons.ETH,
    balance: 0,
    balanceTousd: 0,
    address: '0xf35b194baee5919c19e1494e19eea09d437f805c',
    contract: '0xac6db8954b73ebf10e84278ac8b9b22a781615d9',
    decimals: 18,
    chainId: '0x1',
  },
  {
    coinIcon: TokenIcons.BWB,
    symbol: 'BWB',
    chainName: 'Solana',
    chain: 'sol',
    chainIcon: ChainIcons.Solana,
    balance: 0,
    balanceTousd: 0,
    address: 'EBcUzhkRSTVLHq4KyjGMGRauCqhTPhYDApHeC87BVKwg',
    contract: '6FVyLVhQsShWVUsCq2FJRr1MrECGShc3QxBwWtgiVFwK',
    decimals: 8,
    chainId: '',
  },
  {
    coinIcon: TokenIcons.BWB,
    symbol: 'BWB',
    chainName: 'Base',
    chain: 'base',
    chainIcon: ChainIcons.Base,
    balance: 0,
    balanceTousd: 0,
    address: '0xf35b194baee5919c19e1494e19eea09d437f805c',
    contract: '0x619c4bbbd65f836b78b36cbe781513861d57f39d',
    decimals: 18,
    chainId: '0x2105',
  },
  {
    coinIcon: TokenIcons.BWB,
    symbol: 'BWB',
    chainName: 'Ton',
    chain: 'ton',
    chainIcon: ChainIcons.Ton,
    balance: 0,
    balanceTousd: 0,
    address: 'UQDtSlxfq91O6pQGap6i5IDPanQ63iaUYrimEJqwEilBpW8z',
    contract: 'UQBaWrUZwQMcCEHZHf-dAFVhAWInbA7KJciM1W1aQxg4YWLN',
    decimals: 9,
    chainId: '',
  },
];

export const toTokenList: Token[] = [
  {
    coinIcon: TokenIcons.BGB,
    symbol: 'BGB',
    chainName: 'Ethereum',
    chain: 'eth',
    chainIcon: ChainIcons.ETH,
    balance: 0,
    balanceTousd: 0,
    contract: '',
    address: '',
    decimals: 18,
    chainId: '0x1',
  },
  {
    coinIcon: TokenIcons.BGB,
    symbol: 'BGB',
    chainName: 'Morph',
    chain: 'morph',
    chainIcon: ChainIcons.Morph,
    balance: 0,
    balanceTousd: 0,
    contract: '',
    address: '',
    decimals: 18,
    chainId: '0xb02',
  },
];
